/* WorkTriggerWorkInputTabRenderer.js */

"use strict";
const _ = require("lodash");
const InputControls = require("../../utils/InputControls");

class WorkTriggerWorkInputTabRenderer {
    constructor(model) {
        this._model = model;
        this._gameEditor = this._model.getGameEditor();
        this._rootElem = document.createElement("worktrig-workinput-view-tab-gl");
        this._gridContainerElem = document.createElement("worktrig-workinput-grid-gl");
        this._gridContainerElem.classList.add("grid-container");
        this._rootElem.appendChild(this._gridContainerElem);
        this._rootElem.component = this._model;
        this._workInputControls = undefined;
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        return this._workInputControls
            .shutdown()
            .then(() => {
                this._unregisterListeners();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._gridContainerElem.remove();
                this._gridContainerElem = undefined;
                this._workInputControls = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._workInputControls.on("ValueChange", (this._onWorkInputControlsValueChange = this._onWorkInputControlsValueChange.bind(this)));
        this._model.on("WorkTypeChanged", (this._onWorkTypeChanged = this._onWorkTypeChanged.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._workInputControls.removeListener("ValueChange", this._onWorkInputControlsValueChange);
        this._model.removeListener("WorkTypeChanged", this._onWorkTypeChanged);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (this._gridContainerElem.hasChildNodes()) {
            return Promise.resolve();
        }
        return this.renderWorkInputs();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    renderWorkInputs() {
        if (this._workInputControls) {
            this._workInputControls.shutdown();
        }
        this._workInputControls = new InputControls(this._gameEditor, _.get(this._model.getWorkType(), "workInputs"), this._gridContainerElem, 1);
        return this._workInputControls.render().then(() => {
            let workInputVals = this._model.getWorkInput();
            if (_.isEmpty(workInputVals)) {
                this._model.setWorkInput(this._workInputControls.getValues());
            } else {
                this._workInputControls.setValues(this._model.getWorkInput());
            }
            this._registerListeners();
        });
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onWorkInputControlsValueChange(vals) {
        this._model.setWorkInput(vals);
    }
    _onShutdown() {
        this._shutdown();
    }
    _onWorkTypeChanged() {
        this.renderWorkInputs();
    }
}
module.exports = WorkTriggerWorkInputTabRenderer;
